import React from "react";
import styles from "./styles.module.scss";

const Button = ({
    value,
    color,
    arrow,
    disabled,
    dataTestId,
    classes,
    transparent,
    onClick,
    large,
    autoFocus,
}) => {
    let btnStyle = [styles.btn];

    if (large) btnStyle.push(styles.large);

    if (color) {
        btnStyle.push(styles[color] || "");
    }

    if (transparent) {
        btnStyle.push(styles.transparent);
    }

    if (classes && Array.isArray(classes)) {
        btnStyle = [...btnStyle, ...classes];
    }

    if (arrow) btnStyle.push(styles.arrow);

    return (
        <button
            className={btnStyle.join(" ")}
            value={value}
            disabled={disabled}
            onClick={onClick}
            autoFocus={autoFocus}
            data-testid={dataTestId}
        >
            {value}
        </button>
    );
};

export default Button;
